// Minimum length required for patient data fields
export const MINIMUM_DATA_LENGTH = 5;

export const YEAR_MONTH_FIRST_DAY_FORMAT = 'YYYY-MM-01';
export const DOB_FORMAT = 'YYYY-MM-DD';
export const INVALID_DATE = 'Invalid date';
export const ALL_WHITESPACE_REGEX_TEST = /^\s*$/;
export const CONCESSION_MAXIMUM_NAME_LENGTH = 40;

export const IHI_MEDICARE_INFO_URL = 'https://www.servicesaustralia.gov.au/individual-healthcare-identifiers';
